window.FILTER_APPLY_MODE = 'instant';
const ENABLE_FACET_AVAILABILITY_SYNC = true;
window.NWFiltersDrawer = window.NWFiltersDrawer || {};

function updateFilterToggleIcons(isOpen) {
  const angleDownIcon = document.querySelector('.icon-angle-down');
  const angleUpIcon = document.querySelector('.icon-angle-up');
  if (angleDownIcon) {
    angleDownIcon.style.display = isOpen ? 'none' : 'inline';
  }
  if (angleUpIcon) {
    angleUpIcon.style.display = isOpen ? 'inline' : 'none';
  }
}

function setFiltersDrawerState(isOpen) {
  const facetsContainer = document.querySelector('.filters-drawer-enabled');
  if (!facetsContainer) return;

  const header = document.querySelector('.section-header');
  if (isOpen && header?.classList.contains('visible')) {
    window.toggleMenu?.();
  }

  facetsContainer.classList.toggle('drawer-open', isOpen);
  document.documentElement.classList.toggle('filters-drawer-open', isOpen);
  updateFilterToggleIcons(isOpen);
}

window.NWFiltersDrawer.toggle = () => {
  const facetsContainer = document.querySelector('.filters-drawer-enabled');
  if (!facetsContainer) return;
  const willOpen = !facetsContainer.classList.contains('drawer-open');
  setFiltersDrawerState(willOpen);
  if (willOpen) {
    document.querySelectorAll('facet-filters-form').forEach((formEl) => {
      formEl.refreshActiveFilterChips?.();
    });
  }
};

window.NWFiltersDrawer.close = () => setFiltersDrawerState(false);
window.toggleFilters = () => window.NWFiltersDrawer.toggle();
window.closeFiltersDrawer = () => window.NWFiltersDrawer.close();

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onActiveChipClick = this.onActiveChipClick.bind(this);
    this.onFormInput = this.onFormInput.bind(this);
    this.onApplyButtonClick = this.onApplyButtonClick.bind(this);
    this.onDrawerCloseClick = this.onDrawerCloseClick.bind(this);
    this.onSubmitPreventDefault = this.onSubmitPreventDefault.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    this.facetForm = facetForm;
    this.applyMode = window.FILTER_APPLY_MODE;

    facetForm?.addEventListener('submit', this.onSubmitPreventDefault);
    facetForm?.addEventListener('input', this.onFormInput);

    this.applyButtons = Array.from(this.querySelectorAll('[data-facets-apply]'));
    this.closeButtons = Array.from(this.querySelectorAll('[data-facets-close]'));

    this.applyButtons.forEach((button) => {
      button.addEventListener('click', this.onApplyButtonClick);
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.onDrawerCloseClick);
    });

    this.activeChipsContainer = this.querySelector('.facets-drawer__active-chips');
    this.activeChipsContainer?.addEventListener('click', this.onActiveChipClick);

    this.facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (this.facetWrapper) this.facetWrapper.addEventListener('keyup', onKeyUpEscape);
    this.refreshActiveFilterChips();
  }

  disconnectedCallback() {
    this.facetForm?.removeEventListener('submit', this.onSubmitPreventDefault);
    this.facetForm?.removeEventListener('input', this.onFormInput);
    this.applyButtons?.forEach((button) => {
      button.removeEventListener('click', this.onApplyButtonClick);
    });
    this.closeButtons?.forEach((button) => {
      button.removeEventListener('click', this.onDrawerCloseClick);
    });
    this.activeChipsContainer?.removeEventListener('click', this.onActiveChipClick);
    this.facetWrapper?.removeEventListener('keyup', onKeyUpEscape);
  }

  onSubmitPreventDefault(event) {
    event.preventDefault();
  }

  isDeferredMode() {
    return this.applyMode !== 'instant';
  }

  onFormInput(event) {
    if (!this.facetForm) return;
    const target = event?.target;
    const parentLabel = target?.closest?.('label');

    // Keep color selection single-value: latest click replaces previous one.
    if (
      target?.type === 'checkbox' &&
      target?.name === 'filter.v.option.color' &&
      target?.checked
    ) {
      Array.from(this.facetForm.querySelectorAll('input[type="checkbox"]')).forEach((input) => {
        if (input !== target && input.name === 'filter.v.option.color' && input.checked) {
          input.checked = false;
          input.closest('label')?.classList.remove('active');
        }
      });
    }

    if (parentLabel && (target.type === 'checkbox' || target.type === 'radio')) {
      if (target.type === 'radio') {
        Array.from(this.facetForm.querySelectorAll(`input[type="radio"][name="${target.name}"]`)).forEach((input) => {
          input.closest('label')?.classList.toggle('active', input.checked);
        });
      } else {
        parentLabel.classList.toggle('active', target.checked);
      }
    }
    this.refreshActiveFilterChips();

    if (this.isDeferredMode()) {
      this.classList.add('has-pending-changes');
      return;
    }

    const searchParams = this.createSearchParams(this.facetForm);
    this.onSubmitForm(searchParams, event);
  }

  onApplyButtonClick(event) {
    event.preventDefault();
    window.closeFiltersDrawer?.();
  }

  onDrawerCloseClick(event) {
    event.preventDefault();
    window.closeFiltersDrawer?.();
  }

  onActiveChipClick(event) {
    const chipButton = event.target?.closest?.('[data-facet-chip]');
    if (!chipButton || !this.facetForm) return;

    const inputName = chipButton.dataset.inputName;
    const inputValue = chipButton.dataset.inputValue;
    if (!inputName) return;

    const matchingInput = Array.from(
      this.facetForm.querySelectorAll('input[type="checkbox"], input[type="radio"]')
    ).find((input) => input.name === inputName && input.value === inputValue && input.checked);

    if (!matchingInput) return;

    matchingInput.checked = false;
    matchingInput.closest('label')?.classList.remove('active');
    this.refreshActiveFilterChips();

    if (this.isDeferredMode()) {
      this.classList.add('has-pending-changes');
      return;
    }

    const searchParams = this.createSearchParams(this.facetForm);
    this.onSubmitForm(searchParams, event);
  }

  refreshActiveFilterChips() {
    const chipsContainer = this.activeChipsContainer;
    if (!chipsContainer || !this.facetForm) return;

    chipsContainer.innerHTML = '';
    const uniqueSelections = new Set();
    const selectedInputs = Array.from(
      this.facetForm.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
    );

    selectedInputs.forEach((input) => {
      if (!input.name || input.name === 'options[prefix]' || input.name === 'q') return;
      if (input.name === 'sort_by') return;
      const key = `${input.name}::${input.value}`;
      if (uniqueSelections.has(key)) return;
      uniqueSelections.add(key);

      const labelText = input.closest('label')?.querySelector('.facet-checkbox__text')?.textContent?.trim();
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'facets-drawer__active-chip';
      chip.dataset.facetChip = 'true';
      chip.dataset.inputName = input.name;
      chip.dataset.inputValue = input.value;
      chip.setAttribute('aria-label', `Remove ${labelText || input.value} filter`);
      chip.textContent = labelText || input.value;
      chipsContainer.appendChild(chip);
    });

    this.updateActiveFiltersCount();
  }

  updateActiveFiltersCount() {
    const activeLabel = this.querySelector('.facets-drawer__active-label');
    if (!activeLabel) return;
    const count = this.querySelectorAll('.facets-drawer__active-chip').length;
    activeLabel.textContent = `Active Filters [${count}]`;
  }

  static setListeners() {
    if (FacetFiltersForm.listenersBound) return;

    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    FacetFiltersForm.onHistoryChangeHandler = onHistoryChange;
    window.addEventListener('popstate', FacetFiltersForm.onHistoryChangeHandler);

    FacetFiltersForm.onEscapeKeyHandler = (event) => {
      if (event.key === 'Escape') {
        window.closeFiltersDrawer?.();
      }
    };
    window.addEventListener('keydown', FacetFiltersForm.onEscapeKeyHandler);

    FacetFiltersForm.onApplyButtonCaptureHandler = (event) => {
      const applyButton = event.target?.closest?.('[data-facets-apply]');
      if (!applyButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.closeFiltersDrawer?.();
    };
    document.addEventListener('click', FacetFiltersForm.onApplyButtonCaptureHandler, true);

    FacetFiltersForm.listenersBound = true;
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    searchParams = FacetFiltersForm.withSilentAvailabilityFilter(searchParams);
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm.latestRenderRequestId += 1;
    const requestId = FacetFiltersForm.latestRenderRequestId;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.add('loading');

    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    if (!sections.length) {
      FacetFiltersForm.recoverLoadingState();
      return;
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.filterData.has(url)
        ? FacetFiltersForm.renderSectionFromCache(url, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event, requestId);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    };
  }

  static renderSectionFromFetch(url, event, requestId) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== FacetFiltersForm.latestRenderRequestId) return;
        const html = responseText;
        FacetFiltersForm.filterData.set(url, html);
        if (ENABLE_FACET_AVAILABILITY_SYNC) {
          FacetFiltersForm.syncFacetAvailabilityFromHtml(html);
        }
        FacetFiltersForm.applyBaseColorAvailability(html);
        //FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(document.getElementById('ProductGridContainer'));
        }
      })
      .catch((error) => {
        console.error('Facet section render failed:', error);
        FacetFiltersForm.recoverLoadingState();
      });
  }

  static renderSectionFromCache(url, event) {
    const html = FacetFiltersForm.filterData.get(url);
    if (!html) return;
    if (ENABLE_FACET_AVAILABILITY_SYNC) {
      FacetFiltersForm.syncFacetAvailabilityFromHtml(html);
    }
    FacetFiltersForm.applyBaseColorAvailability(html);
    //FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(document.getElementById('ProductGridContainer'));
    }
  }

  static recoverLoadingState() {
    document.getElementById('ProductGridContainer')?.querySelector('.collection')?.classList.remove('loading');
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    countContainer?.classList.remove('loading');
    countContainerDesktop?.classList.remove('loading');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderProductGridContainer(html) {
    const currentGridContainer = document.getElementById('ProductGridContainer');
    if (!currentGridContainer) {
      FacetFiltersForm.recoverLoadingState();
      return;
    }

    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const nextGridContainer = parsedDocument.getElementById('ProductGridContainer');
    if (!nextGridContainer) {
      FacetFiltersForm.recoverLoadingState();
      return;
    }

    currentGridContainer.innerHTML = nextGridContainer.innerHTML;

    currentGridContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

      if (typeof updateFormWithUrlParams === 'function') {
        updateFormWithUrlParams();
      }
      
      // Re-initialize variant image events for newly rendered products
      if (typeof initializeVariantImageEvents === 'function') {
        initializeVariantImageEvents();
      }
      
      // Re-initialize collection page handlers if available
      if (typeof initializeCollectionPage === 'function') {
        initializeCollectionPage();
      }

      if (typeof window.resetCollectionInfiniteScrollState === 'function') {
        window.resetCollectionInfiniteScrollState();
      } else {
        document.dispatchEvent(new Event('collection:filters:updated'));
      }
      FacetFiltersForm.recoverLoadingState();
  }

  static renderProductCount(html) {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const parsedCount = parsedDocument.getElementById('ProductCount');
    if (!parsedCount) {
      FacetFiltersForm.recoverLoadingState();
      return;
    }
    const count = parsedCount.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (!container) {
      FacetFiltersForm.recoverLoadingState();
      return;
    }
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static syncFacetAvailabilityFromHtml(html) {
    const baseColorParam = 'filter.v.t.shopify.color-pattern';
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const sourceForm = parsedDocument.getElementById('FacetFiltersForm');
    const targetForm = document.getElementById('FacetFiltersForm');
    if (!sourceForm || !targetForm) return;

    const availableByName = new Map();
    sourceForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      if (!input.name || input.name === 'sort_by' || input.name === 'q' || input.name === 'options[prefix]') return;
      // Base colors use hide/show only — skip enable/disable greying.
      if (input.name === baseColorParam) return;
      if (!availableByName.has(input.name)) availableByName.set(input.name, new Set());
      if (!input.disabled || input.checked) {
        availableByName.get(input.name).add(input.value);
      }
    });

    targetForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach((input) => {
      if (!input.name || !availableByName.has(input.name)) return;
      if (input.name === 'sort_by' || input.name === 'q' || input.name === 'options[prefix]') return;
      if (input.name === baseColorParam) return;

      const isAvailable = availableByName.get(input.name).has(input.value) || input.checked;
      const label = input.closest('label');
      input.disabled = !isAvailable;
      if (label) {
        label.classList.toggle('facet-checkbox--disabled', !isAvailable);
        label.classList.toggle('disabled', !isAvailable);
      }
    });
  }

  static renderFilters(html, event) {
    
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
     // document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
   // FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * Silently keep filter.v.availability=1 whenever any other storefront filter is active.
   * Availability is hidden in the UI (facets.liquid) but still applied via the URL.
   * Sort-only / unfiltered views do not force availability.
   */
  static withSilentAvailabilityFilter(searchParams) {
    const params = new URLSearchParams(searchParams || '');
    const availabilityKey = 'filter.v.availability';
    let hasCustomerFilter = false;

    params.forEach((_value, key) => {
      if (key.startsWith('filter.') && key !== availabilityKey) {
        hasCustomerFilter = true;
      }
    });

    if (hasCustomerFilter) {
      params.set(availabilityKey, '1');
    } else {
      params.delete(availabilityKey);
    }

    return params.toString();
  }

  /**
   * Show/hide base-color swatches from current filter HTML. No enable/disable.
   * Must use .hidden (display:none !important) — .facets__item { display:flex }
   * overrides the HTML [hidden] attribute.
   */
  static pruneUnavailableBaseColors(html) {
    const baseColorParam = 'filter.v.t.shopify.color-pattern';
    const sourceForm = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetFiltersForm');
    const targetForm = document.getElementById('FacetFiltersForm');
    if (!sourceForm || !targetForm) return;

    const sourceInputs = sourceForm.querySelectorAll(`input[name="${baseColorParam}"]`);
    if (!sourceInputs.length) return;

    const availableValues = new Set();
    sourceInputs.forEach((input) => {
      if (!input.disabled || input.checked) availableValues.add(input.value);
    });

    targetForm.querySelectorAll(`input[name="${baseColorParam}"]`).forEach((input) => {
      const item = input.closest('.facets__item');
      if (!item) return;
      const isVisible = input.checked || availableValues.has(input.value);
      item.classList.toggle('hidden', !isVisible);
    });
  }

  /**
   * Hide empty base colors for the rendered filter set.
   * Reuse the rendered HTML only when it already carries availability=1; with no
   * filters that param is dropped, so probe separately or every color looks available.
   */
  static applyBaseColorAvailability(html) {
    const renderedParams = new URLSearchParams(FacetFiltersForm.searchParamsPrev || '');
    if (renderedParams.get('filter.v.availability') === '1') {
      FacetFiltersForm.pruneUnavailableBaseColors(html);
      return;
    }
    FacetFiltersForm.probeBaseColorAvailability(FacetFiltersForm.searchParamsPrev);
  }

  /** Fetch facets for the given filters with availability forced on, then hide empties. */
  static probeBaseColorAvailability(searchParams) {
    const baseColorParam = 'filter.v.t.shopify.color-pattern';
    const targetForm = document.getElementById('FacetFiltersForm');
    if (!targetForm?.querySelector(`input[name="${baseColorParam}"]`)) return;

    const sections = FacetFiltersForm.getSections();
    if (!sections.length) return;

    const params = new URLSearchParams(searchParams || '');
    params.set('filter.v.availability', '1');
    params.delete('page');
    params.delete('gotopage');
    params.delete('section_id');

    const startedWithParams = FacetFiltersForm.searchParamsPrev;

    fetch(`${window.location.pathname}?section_id=${sections[0].section}&${params.toString()}`)
      .then((response) => response.text())
      .then((html) => {
        if (FacetFiltersForm.searchParamsPrev !== startedWithParams) return;
        FacetFiltersForm.pruneUnavailableBaseColors(html);
      })
      .catch(() => {});
  }

  static pruneBaseColorsOnLoad() {
    FacetFiltersForm.probeBaseColorAvailability(window.location.search.slice(1));
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid?.dataset?.id;
    if (!sectionId) return [];

    return [
      {
        section: sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const divs = document.querySelectorAll(".facets__wrapper .facets__disclosure");
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const eventTarget = event.target;
    if (eventTarget?.classList?.contains('mobile-facets__checkbox')) {
      const parentForm = eventTarget.closest('form');
      if (!parentForm) return;
      const searchParams = this.createSearchParams(parentForm);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const sourceForm = eventTarget?.closest?.('form');
      if (!sourceForm) return;
      const isMobile = sourceForm.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = new Map();
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.listenersBound = false;
FacetFiltersForm.latestRenderRequestId = 0;
FacetFiltersForm.onApplyButtonCaptureHandler = null;
if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}
FacetFiltersForm.setListeners();
FacetFiltersForm.pruneBaseColorsOnLoad();
updateFilterToggleIcons(false);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
